var R = /* @__PURE__ */ ((D) => (D.verified = "VERIFIED", D.in_review = "IN_REVIEW", D.failed = "FAILED", D.approved = "APPROVED", D.card_enrolled = "CARD_ENROLLED", D.fraud = "FRAUD", D))(R || {});
export {
  R as XenditCreditCardStatusEnum
};
